"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSnackbarList = void 0;
var components_1 = require("@wordpress/components");
var styled_components_1 = __importDefault(require("styled-components"));
var alert_style_1 = require("../alert/alert-style");
exports.StyledSnackbarList = (0, styled_components_1.default)(components_1.SnackbarList)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &&& {\n    & .components-snackbar {\n      ", "\n    }\n\n    & > div {\n      &:not(:first-of-type) {\n        & > .components-snackbar-list__notice-container {\n          padding-top: 8px;\n        }\n      }\n    }\n  }\n"], ["\n  &&& {\n    & .components-snackbar {\n      ", "\n    }\n\n    & > div {\n      &:not(:first-of-type) {\n        & > .components-snackbar-list__notice-container {\n          padding-top: 8px;\n        }\n      }\n    }\n  }\n"])), alert_style_1.AlertStyle);
var templateObject_1;
